module.exports = __webpack_public_path__ + "img/search_black_24dp.03bb87e7.svg";